import { Component, forwardRef, inject, Input } from '@angular/core';
import {
  AbstractControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { UserStore } from '../../../stores/user/user.state';
import { FormFieldWrapperComponent } from '../../molecules/form-field-wrapper/form-field-wrapper.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgIf } from '@angular/common';
import { SharedModule } from 'primeng/api';

@Component({
  selector: 'app-user-dropdown',
  standalone: true,
  imports: [
    FormFieldWrapperComponent,
    MultiSelectModule,
    NgIf,
    SharedModule,
    FormsModule,
  ],
  templateUrl: './user-dropdown.component.html',
  styleUrl: './user-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UserDropdownComponent),
      multi: true,
    },
  ],
})
export class UserDropdownComponent {
  readonly userStore = inject(UserStore);

  selection: string[] = [];
  touched = false;
  disabled = false;

  @Input() label = 'Nutzer:innen';
  @Input() name = 'user';
  @Input() colSize: string | number = 12;
  @Input() formField: AbstractControl | null = null;

  protected onChange = (value: any) => {};
  private onTouched = () => {
    this.touched = false;
  };

  writeValue(value: any): void {
    this.selection = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  selectIcon(tag: any): void {
    this.selection = tag;
    this.onChange(tag);
    this.onTouched();
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
